import * as React from 'react';
import { debounce } from 'perfect-debounce';
import { accentUtils } from '../../services/HelperService';
import { AccentTextUnbound } from '../unbound/AccentTextUnBound';
import { ConfiguratorContext } from './ConfigContextProvider';
import { useValidation, setOptionValueChanged, isReadOnly, toGuid, getOptionModel, useRefreshKeyExpression } from './ProductConfiguratorShared';


function picklistValue(model) {
    return `${model.CurrentValueAsString ?? ''}_${model.CustomValue ?? ""}`;
}

export const ConfigPicklist = props => {

    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);

    const updateSpecify = React.useRef(debounce(setOptionValueChanged, 800, { trailing: false }));

    const validation = useValidation(props.optionID, "ConfigPicklist");

    const [value, setValue] = React.useState(picklistValue(optionModel));

    const refreshKey = useRefreshKeyExpression(props.optionID, picklistValue, value);

    const [customValue, setCustomValue] = React.useState(optionModel.CustomValue);

    const onTextChange = React.useCallback(e => {
        setCustomValue(e);

        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);

    const onTextBlur = React.useCallback(e => {
        let newValue = e;
        let valID = null;
        if (optionModel.OrderLineOption.ProductOptionValueID != toGuid(accentUtils.getEmptyGuid())) {

            const pov = optionModel.GetProductOptionValue(optionModel.OrderLineOption.ProductOptionValueID);

            if (pov != null) {
                newValue = `${pov.Description}: ${e}`;

                valID = pov.ID.toString();
            }
        }

        if (optionModel.OrderLineOption != null) {
            optionModel.OrderLineOption.CustomValue = newValue;
        }

        updateSpecify.current(ctx, optionModel);

        setValue(`${valID ?? ""}_${newValue ?? ""}`);
    }, [ctx, optionModel, updateSpecify]);


    const data = React.useMemo(() => optionModel.FilteredItems.toArray().map(x => ({ ID: x.ItemKey.toString().toUpperCase(), Value: x.ItemValue })), [optionModel, refreshKey.refreshID]);

    const onChange = React.useCallback(e => {
        const id = toGuid(e.target.value);

        const value = optionModel.GetProductOptionValue(id);

        optionModel.SetValue(window.InsyteConfig.OptionModelSetValueArgs.From(id, value?.Description?? null));

        setOptionValueChanged(ctx, optionModel);


        if (accentUtils.isNull(value) || (value?.CustomValue??false)) {
            setCustomValue(null);
        }

        setValue(`${id?.toString() ?? ""}_${""}`);
    }, [ctx, optionModel, setCustomValue]);

    

    const readOnly = isReadOnly(optionModel);
    

    const pov = optionModel.GetProductOptionValue(optionModel.OrderLineOption.ProductOptionValueID);

    const isCusomValue = accentUtils.isNull(pov) ? false : pov.CustomValue;

    const currValue = optionModel.CurrentValueAsString?.toUpperCase();
    const emptyGuid = accentUtils.getEmptyGuid().toUpperCase();
    const hasCurrentValue = data.some(x => x.ID === currValue);
    const hasEmptyGuidOption = data.some(x => x.ID === emptyGuid);
    const selectedValue = hasCurrentValue ? currValue : (hasEmptyGuidOption ? emptyGuid : "");

    const isRequired = validation.required && accentUtils.isEmpty(currValue);


    return <div className="config-control config-picklist">
        <div className="config-picklist-picklist">
            <select
                className={`config-select ${isRequired ? "required" : ""}`}
                onChange={onChange}
                disabled={readOnly}
                value={selectedValue}
            >
                {data.map(x => <option key={`k_${x.ID}`} value={x.ID}>{x.Value}</option>)}
            </select>
        </div>
        {isCusomValue && <div className="config-picklist-custom">
            <AccentTextUnbound
                key={`${refreshKey.refreshID}`}
                required={validation.required}
                defaultValue={customValue}
                onChange={onTextChange}
                onBlur={onTextBlur}
                disabled={readOnly}
            />
        </div>}
    </div>;
};
